import { Link } from 'react-router-dom';

export default function Profile() {
  const user = {
    name: 'أحمد محمد',
    email: 'ahmed@example.com',
    phone: '0501234567',
    avatar: 'https://public.readdy.ai/ai/img_res/669a7acd19d1ae989d260bb9496c7e0d.jpg'
  };

  const stats = [
    { label: 'الطلبات', value: '12', icon: 'ri-shopping-bag-line', color: 'from-blue-400 to-blue-600' },
    { label: 'المفضلة', value: '24', icon: 'ri-heart-line', color: 'from-red-400 to-red-600' },
    { label: 'النقاط', value: '850', icon: 'ri-star-line', color: 'from-yellow-400 to-yellow-600' }
  ];

  const menuItems = [
    { icon: 'ri-shopping-bag-line', title: 'طلباتي', desc: 'عرض وتتبع طلباتك', link: '/orders', color: 'from-blue-500 to-blue-600' },
    { icon: 'ri-heart-line', title: 'المفضلة', desc: 'المنتجات المحفوظة', link: '/favorites', color: 'from-red-500 to-pink-500' },
    { icon: 'ri-map-pin-line', title: 'العناوين', desc: 'إدارة عناوين التوصيل', link: '#', color: 'from-green-500 to-green-600' },
    { icon: 'ri-wallet-line', title: 'المحفظة', desc: 'الرصيد والمدفوعات', link: '#', color: 'from-purple-500 to-purple-600' },
    { icon: 'ri-notification-line', title: 'الإشعارات', desc: 'إدارة الإشعارات', link: '/notifications', color: 'from-orange-500 to-orange-600' },
    { icon: 'ri-settings-line', title: 'الإعدادات', desc: 'إعدادات الحساب', link: '#', color: 'from-gray-500 to-gray-600' },
    { icon: 'ri-customer-service-line', title: 'الدعم الفني', desc: 'تواصل معنا', link: '#', color: 'from-teal-500 to-teal-600' },
    { icon: 'ri-information-line', title: 'عن التطبيق', desc: 'معلومات وسياسات', link: '#', color: 'from-indigo-500 to-indigo-600' }
  ];

  return (
    <div className="min-h-screen bg-gradient-to-br from-gray-50 via-white to-purple-50 pb-20" dir="rtl">
      {/* Header */}
      <div className="bg-gradient-to-r from-blue-500 to-purple-500 pt-12 pb-24 px-4">
        <div className="flex items-center justify-between mb-6">
          <h1 className="text-2xl font-bold text-white">حسابي</h1>
          <button className="w-10 h-10 bg-white/20 backdrop-blur-sm rounded-full flex items-center justify-center">
            <i className="ri-edit-line text-white text-lg"></i>
          </button>
        </div>

        {/* Profile Card */}
        <div className="bg-white rounded-3xl p-5 shadow-xl">
          <div className="flex items-center gap-4 mb-4">
            <div className="w-20 h-20 rounded-full overflow-hidden ring-4 ring-white shadow-lg">
              <img 
                src={user.avatar}
                alt={user.name}
                className="w-full h-full object-cover object-top"
              />
            </div>
            <div className="flex-1">
              <h2 className="text-xl font-bold text-gray-800 mb-1">{user.name}</h2>
              <p className="text-gray-500 text-sm mb-1">{user.email}</p>
              <p className="text-gray-500 text-sm">{user.phone}</p>
            </div>
          </div>

          {/* Stats */}
          <div className="grid grid-cols-3 gap-3 pt-4 border-t border-gray-100">
            {stats.map((stat, index) => (
              <div key={index} className="text-center">
                <div className={`w-12 h-12 bg-gradient-to-br ${stat.color} rounded-xl flex items-center justify-center mx-auto mb-2`}>
                  <i className={`${stat.icon} text-white text-xl`}></i>
                </div>
                <p className="text-2xl font-bold text-gray-800 mb-1">{stat.value}</p>
                <p className="text-xs text-gray-500">{stat.label}</p>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Menu Items */}
      <div className="px-4 -mt-12">
        <div className="bg-white rounded-3xl shadow-lg p-4">
          {menuItems.map((item, index) => (
            <Link
              key={index}
              to={item.link}
              className="flex items-center gap-4 p-4 hover:bg-gray-50 rounded-2xl transition-all duration-300 group"
            >
              <div className="w-12 h-12 bg-gray-50 rounded-xl flex items-center justify-center group-hover:scale-110 transition-transform duration-300">
                <i className={`${item.icon} text-2xl ${item.color}`}></i>
              </div>
              <span className="flex-1 font-medium text-gray-800">{item.title}</span>
              <i className="ri-arrow-left-s-line text-gray-400 text-xl"></i>
            </Link>
          ))}
        </div>

        {/* Logout Button */}
        <button className="w-full mt-4 py-4 bg-white rounded-2xl shadow-md font-bold text-red-500 hover:bg-red-50 transition-all duration-300 flex items-center justify-center gap-2">
          <i className="ri-logout-box-line text-xl"></i>
          تسجيل الخروج
        </button>
      </div>

      {/* Bottom Navigation */}
      <nav className="fixed bottom-0 w-full bg-white shadow-lg border-t border-gray-100 z-50">
        <div className="grid grid-cols-5 h-16">
          <Link to="/" className="flex flex-col items-center justify-center gap-1 text-gray-400 hover:text-gray-600 transition-colors">
            <i className="ri-home-line text-xl"></i>
            <span className="text-xs">الرئيسية</span>
          </Link>
          <Link to="/explore" className="flex flex-col items-center justify-center gap-1 text-gray-400 hover:text-gray-600 transition-colors">
            <i className="ri-search-line text-xl"></i>
            <span className="text-xs">استكشف</span>
          </Link>
          <Link to="/cart" className="flex flex-col items-center justify-center gap-1 text-gray-400 hover:text-gray-600 transition-colors relative">
            <i className="ri-shopping-cart-line text-xl"></i>
            <span className="text-xs">السلة</span>
            <span className="absolute top-1 right-1/2 translate-x-3 w-5 h-5 bg-gradient-to-r from-red-500 to-pink-500 text-white text-xs font-bold rounded-full flex items-center justify-center">3</span>
          </Link>
          <Link to="/favorites" className="flex flex-col items-center justify-center gap-1 text-gray-400 hover:text-gray-600 transition-colors">
            <i className="ri-heart-line text-xl"></i>
            <span className="text-xs">المفضلة</span>
          </Link>
          <button className="flex flex-col items-center justify-center gap-1 text-blue-600">
            <i className="ri-user-fill text-xl"></i>
            <span className="text-xs">حسابي</span>
          </button>
        </div>
      </nav>
    </div>
  );
}
